<template>
	<div class="home">
		<div class="title-box">
			<div class="breadcrumb-box" style="padding-left: 160px">
				<el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
					<!-- 智能照明 > 案例分享 > 案例详情 -->
					<el-breadcrumb-item to="/smart_lighting">智能照明</el-breadcrumb-item>
					<!-- <el-breadcrumb-item to="/smart_lighting/#dasgin_share">家装案例</el-breadcrumb-item> -->
					<el-breadcrumb-item>案例详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="title">{{ dataValue.title }}</div>
			<div class="fx" @click="shareChange">
				<div class="fx_icon" style="margin-top: 8px">
					<!-- <img src="../image/fenxiang.png" alt="" /> -->
				</div>
				<div class="txt" style="margin-top: 5px">分享</div>
			</div>
		</div>

		<div class="info">
			<div class="info-left" v-if="dataValue.createtime">
				发布时间：{{ dataValue.createtime }}
			</div>
			<div class="info-right" v-if="dataValue.author"> 作者：{{ dataValue.author }} </div>
		</div>

		<!--  -->
		<div class="content-box">
			<div class="content" v-html="dataValue.details_text"></div>
			<div class="operate">
				<!-- 上一个案例 -->
				<div class="operate-left">
					<div class="operate-left-top" v-if="startValue != '无内容'">
						<span @click="detailsChange(startValue[0].id)">上一个案例</span>
					</div>
					<div
						class="operate-box"
						v-if="startValue != '无内容'"
						@click="detailsChange(startValue[0].id)"
					>
						<div class="operate-box-left">
							<img :src="startValue[0].banner_text" />
						</div>
						<div class="operate-box-right">
							<div class="title">
								{{ startValue[0].title }}
							</div>
							<div class="btn">
								查看详情
								<div class="icon">
									<!-- <img src="../image/jiantou1.png" alt="" /> -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 下一个案例 -->
				<div class="operate-left">
					<div class="operate-left-top" v-if="endValue != '无内容'">
						<span @click="detailsChange(endValue[0].id)">下一个案例</span>
					</div>
					<div
						class="operate-box"
						v-if="endValue != '无内容'"
						@click="detailsChange(endValue[0].id)"
					>
						<div class="operate-box-left">
							<img :src="endValue[0].banner_text" />
						</div>
						<div class="operate-box-right">
							<div class="title">
								{{ endValue[0].title }}
							</div>
							<div class="btn">
								查看详情
								<div class="icon">
									<!-- <img src="../image/jiantou1.png" alt="" /> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="bj">
				<img src="../image/qiu3.png" alt="" />
			</div>
		</div>

		<!-- 弹出框 -->
		<el-dialog title="" :visible.sync="centerDialogVisible" width="460px">
			<template slot="title">
				<div title="title_top_img">
					<!-- <img src="../assets/imgs/al1.png" alt="" /> -->
					<img style="width: 100%" :src="case_banner" alt="" />
				</div>
			</template>
			<div class="dialog_content">
				<div class="left">
					<div class="top">{{ dataValue.title }}</div>
					<div class="bottom">
						<span>打开微信，扫码分享</span>
						<img src="../assets/icon/down_1@2x.png" alt="" />
					</div>
				</div>

				<!-- 二维码 -->
				<div class="right">
					<!-- <img :src="qr_code_url" alt="" /> -->
					<vue-qr ref="refqr" :callback="codeImg" :text="urlParams" :size="200"></vue-qr>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { $designShareDetails, $getQeCode } from '../api/index';
	import vueQr from 'vue-qr';
	// @ is an alias to /src
	export default {
		data() {
			return {
				id: null,
				centerDialogVisible: false,
				shareDetail: {},
				dataValue: {},
				endValue: [{ banner_text: '' }],
				startValue: [{ banner_text: '' }],
				urlParams: '',
				case_banner: '', // 分享顶图
				qr_code_url: '', // 二维码地址
			};
		},
		created() {
			this.id = this.$route.query.id;
			this.designShareDetails();
			let urlParmas = `${document.location.protocol}//${document.domain}${
				document.location.port ? ':' + document.location.port : ''
			}`;
			this.urlParams = `${document.location.protocol}//${document.domain}${
				document.location.port ? ':' + document.location.port : ''
			}${document.location.pathname}?id=${this.id}`;

			// $getQeCode({ id: this.id, url: urlParmas })
			//   .then((res) => {
			//     this.qr_code_url = res.data;
			//   })
			//   .catch((err) => {
			//     console.log(err);
			//   });
		},
		computed: {
			//计算属性
		},
		components: {
			vueQr,
		},
		mounted() {},
		methods: {
			codeImg(url, id) {
				this.qr_code = url;
			},
			designShareDetails() {
				$designShareDetails({ id: this.id }).then((res) => {
					this.shareDetail = res.data;
					res.data.data_value.details_text = res.data.data_value.details_text.replaceAll(
						'<video',
						'<video autoplay autostart="true" '
					);
					this.dataValue = res.data.data_value;
					this.endValue = res.data.end_value;
					this.startValue = res.data.start_value;
					// console.log('分享数据', this.id, res.data);
					this.case_banner = res.data.data_value.banner;
				});
			},

			// 分享
			shareChange() {
				// console.log('分享');
				this.centerDialogVisible = true;
			},

			// 详情 跳转
			detailsChange(id) {
				this.id = id;
				this.urlParams = `${document.location.protocol}//${document.domain}${
					document.location.port ? ':' + document.location.port : ''
				}${document.location.pathname}?id=${this.id}`;
				this.$router.replace({ query: { id } });
				this.designShareDetails();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.title-box {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 113px;
		margin-bottom: 33px;
		position: relative;

		.breadcrumb-box {
			position: absolute;
			left: 0;
			top: calc(-113px + 31px);
			padding-left: calc(var(--proportion) * 160px) !important;
		}

		.title {
			font-size: 40px;

			font-weight: bold;
			color: #ffffff;
			opacity: 0.85;
		}
		.fx {
			font-size: 12px;

			font-weight: 400;
			color: #ffffff;
			text-align: center;
			opacity: 0.85;
			width: 52px;
			height: 52px;
			background: #282727;
			// opacity: 0.1;
			border-radius: 4px;
			margin-left: 32px;
			cursor: pointer;
			.fx_icon {
				width: 16px;
				height: 16px;
				margin: 0 auto;
				background: url('../image/fenxiang.png') no-repeat;
			}
			&:hover {
				color: #e60000;
			}
			&:hover .fx_icon {
				color: #e60000;
				background: url('../image/fenxiang1.png') no-repeat;
			}
		}
	}
	.info {
		font-size: 14px;

		font-weight: 400;
		color: #ffffff;
		opacity: 0.5;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 33px;
		border-bottom: 1px solid #100f0f;
		background: #100f0f;
		box-shadow: 0px 1px 0px 0px #333333;
		.info-left {
			margin-right: 24px;
		}
	}

	.content-box {
		position: relative;
		z-index: 9;
		.content {
			position: relative;
			z-index: 9;
			margin: 0px auto;
			width: 1200px;
			min-height: 200px;
			color: #fff;

			word-break: break-all;

			::v-deep {
				video,
				img {
					max-width: 100%;
				}
			}
		}
		.operate {
			display: flex;
			justify-content: space-between;
			// width: 75%;
			width: 1200px;
			// margin-left: 12.5%;
			margin: 0 auto;
			margin-top: 70px;
			padding-bottom: 105px;

			&-left {
				width: 383px;
				z-index: 999;
				.operate-left-top {
					font-size: 16px;

					font-weight: 400;
					color: #ffffff;
					opacity: 0.5;
					span {
						cursor: pointer;
					}
				}
				.operate-box {
					cursor: pointer;
					display: flex;
					background: #202020;
					padding: 14px;
					margin-top: 15px;
					&-left {
						img {
							width: 132px;
							height: 109px;
							object-fit: cover;
						}
					}
					&-right {
						margin-left: 20px;

						flex: 1;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						.title {
							font-size: 16px;

							font-weight: bold;
							color: #ffffff;
							opacity: 0.85;

							margin-top: 9px;
							word-break: break-all;
							text-overflow: ellipsis;
							overflow: hidden;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2; /* 这里是超出几行省略 */
						}
						.btn {
							width: 80px;
							font-size: 14px;

							font-weight: 400;
							color: #ffffff;
							opacity: 0.5;
							margin-top: 30px;
							cursor: pointer;
							.icon {
								display: inline-block;
								width: 16px;
								height: 16px;
								vertical-align: bottom;
								margin-bottom: -1px;
								background: url('../image/jiantou1.png') no-repeat;
							}
							&:hover {
								color: #e60000;
								opacity: 1;
							}
							&:hover .icon {
								background: url('../image/jiantou2.png') no-repeat;
							}
						}
					}
				}
			}
			// &-right { }
		}
		.bj {
			position: absolute;
			bottom: 0;
			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	::v-deep {
		.el-dialog__header,
		.el-dialog__body {
			padding: 0;
		}

		.el-dialog__close {
			position: absolute;
			top: -22px;
			right: -53px;
			font-size: 16px;
			&:hover {
				color: #e60000;
			}
		}

		.el-dialog {
			transform: scale(calc(var(--proportion) / 1));
		}

		// 面包屑
		.el-breadcrumb__inner {
			font-size: 14px;

			font-weight: 400;
			color: #999999 !important;
			&:hover {
				color: $theme-color !important;
			}
		}
	}
	.dialog_content {
		width: 100%;
		height: 152px;
		padding: 32px;
		box-sizing: border-box;
		display: flex;
		.left {
			flex: 1;
			margin-right: 56px;
			// background: #ccc;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.top {
				margin-top: -3px;
				font-size: 18px;

				font-weight: bold;
				color: #333333;
				line-height: 28px;

				word-break: break-all;
				text-overflow: ellipsis;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2; /* 这里是超出几行省略 */
			}
			.bottom {
				margin-bottom: -3px;
				display: flex;
				align-items: center;
				font-size: 14px;

				font-weight: 500;
				color: #999999;
				span {
					margin-right: 5px;
				}
				img {
					width: 24px;
					height: 24px;
					margin-bottom: 2px;
				}
			}
		}
		.right {
			width: 88px;
			height: 88px;
			img {
				width: 100%;
				height: 100%;
			}
		}
	}
</style>
